(ns teamoesterreich.user-mode.syncer
  (:require [clojure.walk]
            [reagent.core :as r]
            [shadow.cljs.modern :refer (js-await)]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.config :as config]
            [teamoesterreich.firebase.provider :as fs-provider]
            [teamoesterreich.store :as store]
            [teamoesterreich.user-mode.backend :as backend]))



(defn get-bonn-posts []
  (js-await [response (js/fetch (str backend/BASE_URL "/bonn-specials/get-news"))]
            (js-await [body (.json response)]
                      (swap! store/app-state assoc
                             :bonn-posts (into {} (map (fn [e] [(get e :id) e])
                                                       (js->clj body {:keywordize-keys true})))))))

(defn get-events [!actual-user]
  (let [!event-list (r/cursor store/app-state [:actual-events])]
    (when (or (nil? @!event-list) (not= (:forTomId @!event-list) (:tom-id @!actual-user)))
      (reset! !event-list {:list [] :forTomId (:tom-id @!actual-user)})
      (js-await [user (.getUser ^js config/user-manager)]
                (js-await [response (js/fetch (str backend/BASE_URL "/event-list/")
                                              #js{:headers (clj->js (merge {}
                                                                           (when user {:Authorization (str "Bearer " (.-access_token user))})))})]
                          (try
                            (js-await [body (.json response)]
                                      (reset! !event-list {:list     (js->clj body {:keywordize-keys true})
                                                           :forTomId (:tom-id @!actual-user)}
                                              ))
                            (catch js/Error e (log/out "cannot load event-list" e) nil)))
                ))))

(defn get-devices [!actual-user]
  (let [!my-devices (r/cursor store/app-state [:my-devices])]
    (when (or (nil? @!my-devices) (not= (:forTomId @!my-devices) (:tom-id @!actual-user)))
      (reset! !my-devices {:list [] :forTomId (:tom-id @!actual-user)})
      (js-await [user (.getUser ^js config/user-manager)]
                (js-await [response (js/fetch (str backend/BASE_URL "/device-list")
                                              #js{:headers (clj->js (merge {}
                                                                           (when user {:Authorization (str "Bearer " (.-access_token user))})))})]
                          (try
                            (js-await [body (.json response)]
                                      (reset! !my-devices {:list     (js->clj body {:keywordize-keys true})
                                                           :forTomId (:tom-id @!actual-user)}))
                            (catch js/Error e (log/out "cannot load devices-list" e) nil))
                          )))))

;(in-ns 'teamoesterreich.user-mode.syncer) (get-bonn-posts) (get @store/app-state :bonn-posts)

(defn get-all []
  (let [!loaded (r/cursor store/app-state [:loaded])]

    (when-not (:user @!loaded) (fs-provider/load-user (fs-provider/get-uid)))

    ))

